// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"d48ea48f","77":"b364380a","243":"8d26d9ef","493":"1bdb8f3a"}[chunkId] + ".chunk.js";
};